function moveInterscroller() {
  _hrlength = $("#filmContainer").find("hr").length;
  switch (_hrlength) {
    case 1:
      _index = 0;
      break;
    default:
      _index = 1;
      break;
  }
  if (_hrlength >= 2) {
    if (typeof _interscroller != "undefined") {
      $("#filmContainer").find("hr").eq(_index).after(_interscroller);
    } else {
      _interscroller = $("#banner-interscroller").detach();
      $("#filmContainer").find("hr").eq(_index).after(_interscroller);
    }
  }
}

window.addEventListener("filmfilter_apply_filters_finished", () => {
  moveInterscroller();
});

window.addEventListener("vue-movie-listing-filters-applied", () => {
  moveInterscroller();
});
